import type {Component, ComponentProperties, Editor} from 'grapesjs';
import {hideAddElementButtonsForComponent, showAddElementButtonsForComponent} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/add-element-buttons';
import {logEmailMakerError} from '@EmailMakerReact/lib/email-maker-error-library';
import {hideMediaComponentOverlay} from '@EmailMakerReact/lib/email-maker-overlay-library';

const RESIZABLE_PROP = 'resizable';
const HOVERABLE_PROP = 'hoverable';
const TOOLBAR_PROP = 'toolbar';
const SELECTION_REFRESH_EVENT = 'component:toggled';

export interface ComponentInteractionProps {
  resizable: ComponentProperties['resizable'];
  hoverable: ComponentProperties['hoverable'];
  toolbar: ComponentProperties['toolbar'];
}

export function lockComponentForImageCrop(editor: Editor, component: Component, element: HTMLElement): ComponentInteractionProps {
  hideMediaComponentOverlay(editor, element);
  hideAddElementButtonsForComponent(editor, component);

  const previousInteractionProps: ComponentInteractionProps = {
    resizable: component.get(RESIZABLE_PROP),
    hoverable: component.get(HOVERABLE_PROP),
    toolbar: component.get(TOOLBAR_PROP),
  };
  setComponentInteractionProps(editor, component, {resizable: false, hoverable: false, toolbar: []});
  return previousInteractionProps;
}

export function unlockComponentAfterImageCrop(editor: Editor, component: Component, previousInteractionProps: ComponentInteractionProps): void {
  setComponentInteractionProps(editor, component, previousInteractionProps);
  if (editor.getSelected() === component) {
    showAddElementButtonsForComponent(editor, component);
  }
}

function setComponentInteractionProps(editor: Editor, component: Component, props: ComponentInteractionProps): void {
  editor.UndoManager.skip((): void => {
    // skip() restores the prior tracking state only when the callback returns, so it must not throw.
    try {
      component.set({[RESIZABLE_PROP]: props.resizable, [HOVERABLE_PROP]: props.hoverable}, {silent: true});
      component.set(TOOLBAR_PROP, props.toolbar);
    } catch (error) {
      logEmailMakerError('setComponentInteractionProps: failed to update the crop interaction props', error);
    }
  });
  editor.trigger(SELECTION_REFRESH_EVENT);
}
